import { Colleague } from 'store/user/types'

const getKeyString = (item: Colleague) => `${item.userKey}`

export default getKeyString
